import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLocationInquiry } from "~/lib/server-functions/create-location-inquiry";

type CreateLocationInquiryInput = {
  userId?: string;
  locationIds: number[];
  salutation: "Frau" | "Herr" | "Divers";
  firstName: string;
  lastName: string;
  company?: string;
  email: string;
  telephone: string;
  appointments: Array<{ start: Date; end: Date }>;
  eventTypeId: number;
  businessType: "Privat" | "Geschäftlich";
  numberOfRooms?: number;
  numberOfGuests?: number;
  budgetType: "Gesamt" | "Pro Person";
  budget?: number;
  budgetCurrency?: string;
  notes?: string;
  requestedRooms?: Array<{ id: number; name: string }>;
};

export const useCreateLocationInquiryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateLocationInquiryInput) => {
      return await createLocationInquiry({ data });
    },
    onSuccess: () => {
      // Invalidate any relevant queries if needed
      // For now, we'll just return success
    },
  });
};
